import StoplistAPI from '@/api/stoplist'

const state = {
    list: []
};

const mutations = {
    addItem(state, payload) {
        state.list.push(payload);
    },
    removeItem(state, {
        product_id,
        menu_id
    }) {
        state.list = state.list.filter(it => {
            if (it.product_id == product_id && it.menu_id == menu_id) return false;
            
            return true;
        });
    },
    setStoplist(state, data) {
        state.list = data;
    }
};

const actions = {
    fetchStoplist(context) {
        return new Promise((resolve, reject) => {
            StoplistAPI.getStoplist(    
                context.rootState.cafe._id,
                context.rootState.menu.current._id
            ).then(data => {
                context.commit('setStoplist', data.stoplist);
            }).catch(reject);
        });
    },
    addToStoplist(context) {
        return new Promise((resolve, reject) => {
            StoplistAPI.addToStoplist(
                context.rootState.cafe._id,
                context.rootState.menu.current._id,
                context.rootState.menu.product._id
            ).then(data => {
                context.commit('addItem', data.item);
            }).catch(reject);
        });
    },
    removeFromStoplist(context) {
        return new Promise((resolve, reject) => {
            const menu_id = context.rootState.menu.current._id;
            const product_id = context.rootState.menu.product._id;

            StoplistAPI.removeFromStoplist(
                context.rootState.cafe._id,
                menu_id,
                product_id
            ).then(data => {
                context.commit('removeItem', {
                    menu_id,
                    product_id
                });
            }).catch(reject);
        });
    }
};

const getters = {
    isProductStoplisted(state, getters) {
        return (menu_id, product_id) => {
            return !!state.list.find(it => it.product_id == product_id && it.menu_id == menu_id);
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}